module.exports = __webpack_public_path__ + "img/neighborhood.c906715b.jpg";